import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/MDXPageLayout.js";
import PageBanner from '../../components/PageBanner';
import Button from '../../components/Button';
import InternalImage from '../../components/InternalImage';
import { StaticImage } from "gatsby-plugin-image";
import HackavizFooter from '../../components/HackavizFooter';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<PageBanner styleId={1} title={"Hackaviz 2019"} description={"Les données"} mdxType="PageBanner" />
<section id="one">
<div className="inner">
<h1>{`Les déplacements domicile-travail dans la région Occitanie`}</h1>
<p>{`Pour l’Hackaviz 2019, l’association TOULOUSE DATAVIZ met à disposition 2 jeux de données sur la même thématique`}</p>
<InternalImage name={"hackaviz2019-data-0"} altText={"3 types de flux"} mdxType="InternalImage" />
<hr />
<h2>{`par_commune`}</h2>
<p><strong parentName="p">{`Plus simple à prendre en main`}</strong></p>
<p>{`Pour chaque commune (4516 lignes / 43 colonnes) :`}</p>
<ul>
<li parentName="ul">{`Données générales sur la commune`}</li>
<li parentName="ul">{`Flux d’actifs interne, vers d’autres communes de travail, depuis d’autres communes de domicile.`}</li>
<li parentName="ul">{`Données agrégés sur le mode de transport  et les catégories socio-professionnelles`}</li>
<li parentName="ul">{`Données géographiques de la commune`}</li>
</ul>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/par_commune.csv"} text={"par_commune.csv"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/par_commune.xlsx"} text={"par_commune.xls"} mdxType="Button" />
 
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/par_commune.geojson"} text={"par_commune.geojson"} mdxType="Button" />
<hr />
<h2>{`par_trajet`}</h2>
<p><strong parentName="p">{`Flux détaillé de commune à commune`}</strong></p>
<p>{`Pour chaque couple commune domicile – commune de travail (1912 lignes / 23 colonnes)`}</p>
<ul>
<li parentName="ul">{`Données générales sur la commune`}</li>
<li parentName="ul">{`Nombre d’actifs qui vont d’une commune à une autre pour le travail`}</li>
<li parentName="ul">{`Données de distance et de durée de trajets entre les deux communes`}</li>
<li parentName="ul">{`Données géographiques des communes domicile et travail`}</li>
</ul>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/par_trajet.csv"} text={"par_trajet.csv"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/par_trajet.xlsx"} text={"par_trajet.xls"} mdxType="Button" />
<ul>
<li parentName="ul">{`Les jeux de données ont été construits avec des données ouvertes provenant des sites data.gouv.fr, IGN, INSEE. `}</li>
<li parentName="ul">{`Les distances et les durées des trajets entre communes ont été obtenues via l’API Mapbox`}</li>
<li parentName="ul">{`Le séparateur  ‘,’ est utilisé pour les fichiers csv`}</li>
<li parentName="ul">{`Les données de géométrie des communes sont incluses uniquement dans le fichier geojson. Ce format est adapté pour ceux qui souhaitent utiliser des outils de cartographie tels que le logiciel libre `}<a parentName="li" {...{
              "href": "https://www.qgis.org/fr/site/forusers/download.html"
            }}>{`QGIS`}</a>{` ou des librairies javascript telles que `}<a parentName="li" {...{
              "href": "https://d3js.org/"
            }}>{`d3.js`}</a>{`.`}</li>
<li parentName="ul">{`Dans les deux fichiers, certaines variables sont temporelles avec des valeurs pour les années 2009 et 2014.`}</li>
<li parentName="ul">{`Les fichiers xlsx contiennent en plus de l’onglet données, un onglet dictionnaire des données et un onglet données complémentaires`}</li>
</ul>
<hr />
<h2>{`Données complémentaires`}</h2>
<ul>
<li parentName="ul">{`Émission de CO2 par an et par habitant en France en 2016 : `}<strong parentName="li">{`4,38 Tonnes`}</strong></li>
<li parentName="ul">{`Émission CO2 d’un véhicule  : `}<strong parentName="li">{`135 g/km`}</strong>{` ou `}<strong parentName="li">{`13,5 kg/100km`}</strong></li>
</ul>
<hr />
<h2>{`Toutes les explications sur les données`}</h2>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019/blob/master/descriptif_donnees.pdf"} text={"descriptif des données"} mdxType="Button" />
<p>{`Les données et la documentation sont aussi sur notre site github`}</p>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2019"} text={"Github TDV"} mdxType="Button" />
<h3>{`Ceux qui restent, sortent ou rentrent`}</h3>
<InternalImage name={"hackaviz2019-data-1"} altText={"3 types de flux"} mdxType="InternalImage" />
<InternalImage name={"hackaviz2019-data-2"} altText={"par commune"} mdxType="InternalImage" />
<InternalImage name={"hackaviz2019-data-3"} altText={"par trajet"} mdxType="InternalImage" />
<HackavizFooter year={'2019'} mdxType="HackavizFooter" />
</div>
</section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      